// @ts-nocheck
import React from 'react';
import { wrapComponent } from 'unitx-ui';
import * as R from 'unitx/ramda';
import { useEdge } from "../../hooks";
import { getNodeContextByElement } from "../../utils";
import * as V from 'unitx/vector';
import Graphics, { drawLine as defaultDrawLine } from "../Graphics";
import Container from "../Container";

const calculateMidpoint = from => to => R.pipe(V.subtract(from), V.divideScalar(2), V.add(from))(to);

const DEFAULT_BOX = {
  width: 90,
  height: 90
};

function EdgeContainer(props, __) {
  const {
    item,
    graphID,
    children,
    drawLine = defaultDrawLine
  } = props;
  const graphicsRef = React.useRef(null);
  const containerRef = React.useRef(null);

  const drawLineCallback = element => {
    const targetElement = element.target();
    const sourceElement = element.source();
    const to = targetElement.position();
    const from = sourceElement.position();
    const midpoint = calculateMidpoint(from)(to);
    const sourceElementContext = getNodeContextByElement(sourceElement);
    const targetElementContext = getNodeContextByElement(targetElement);
    containerRef.current.x = midpoint.x;
    containerRef.current.y = midpoint.y;
    return drawLine({
      element,
      item,
      sourceElement,
      targetElement,
      graphics: graphicsRef.current,
      to: targetElementContext.boundingBox,
      from: sourceElementContext.boundingBox,
      directed: true
    });
  };

  const onPositionChange = React.useCallback(({
    element
  }) => {
    drawLineCallback(element); // R.ifElse(
    //   R.isNotNil,
    //   () => drawLine?.({
    // element,
    // item,
    // sourceElement,
    // targetElement,
    // graphics: graphicsRef.current,
    // to: targetElementContext.boundingBox,
    // from: sourceElementContext.boundingBox,
    //   }),
    //   () => defaultDrawLine({
    //     to: targetElementContext.boundingBox,
    //     from: sourceElementContext.boundingBox,
    //     graphics: graphicsRef.current,
    //     directed: true,
    //   }),
    // )(drawLine)
  }, [drawLine]);
  const {
    element
  } = useEdge({
    id: item.id,
    source: item.source,
    target: item.target,
    graphID,
    onPositionChange
  });
  React.useEffect(() => {
    drawLineCallback(element);
  }, [drawLine]);
  const sourceElement = element.source();
  const targetElement = element.target();
  const to = element.target().position();
  const from = element.source().position();
  const midpoint = calculateMidpoint(from)(to);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    ref: containerRef,
    style: {
      left: midpoint.x,
      top: midpoint.y
    }
  }, children({
    item,
    element,
    sourceElement,
    targetElement,
    to,
    from
  })), /*#__PURE__*/React.createElement(Graphics, {
    ref: graphicsRef
  }));
}

export default wrapComponent(EdgeContainer, {
  isForwardRef: true
});